import { CONSUMER_RETAIL_LOST_SHOPPER_SLIDES, SlidesByType } from '../constants';

import { UpsellCell } from './types';

const SlidesPerMarket: UpsellCell = {
  all: {
    [SlidesByType.CONSUMER_RETAIL_LOST_SHOPPER]: CONSUMER_RETAIL_LOST_SHOPPER_SLIDES,
  },
};

export default SlidesPerMarket;
